import { render } from "./MemberApplicationTabDataDokumen.vue?vue&type=template&id=30e75179&scoped=true"
import script from "./MemberApplicationTabDataDokumen.vue?vue&type=script&lang=js"
export * from "./MemberApplicationTabDataDokumen.vue?vue&type=script&lang=js"

import "./MemberApplicationTabDataDokumen.vue?vue&type=style&index=0&id=30e75179&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e75179"]])

export default __exports__